import React from 'react';

import { Box } from '@mui/material';

import { AuditValuePropType } from '../../EntityAuditHistory.propTypes';
import { monoValueStyles } from '../../EntityAuditHistory.styles';
import { EntityAuditHistoryTestIds } from '../../EntityAuditHistory.testIds';
import { formatAuditValue } from '../../EntityAuditHistory.utils';

/**
 * A diff value as stored — the look a field renderer falls back to when it can't read the value. It
 * takes its type size from the Was / Became column it sits in.
 */
const AuditRawValue = ({ value = null }) => (
  <Box component="span" data-testid={EntityAuditHistoryTestIds.RAW_VALUE} sx={monoValueStyles}>
    {formatAuditValue(value)}
  </Box>
);

AuditRawValue.propTypes = {
  value: AuditValuePropType,
};

export default AuditRawValue;
